<template>
  <v-app id="inspire" style="margin-left: 10%; margin-right: 10%;">
    <v-app-bar :class="{ 'hover-show': showMenu }" color=white dark app fixed height="80">
      <v-img :src="require('@/assets/rcplogo.png')" max-height="150%" max-width="15%" contain>
        <a href="https://www.rcplac.org/en" target="_blank" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></a>
      </v-img>
      <v-app-bar-title style="width: 10px" class="ml-0 pl-3" >                            
      </v-app-bar-title>
      <template>        
        <v-btn text color="rgb(0, 30, 67)" @click="toggleMenu" :title="showMenu ? 'Block navigation bar' : 'Unlock navigation bar'">
            <v-icon :color="showMenu ? 'green' : 'red'">lock</v-icon>
          </v-btn>
      </template>
      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn text :to="{ name: 'Inicio' }" color="rgb(0, 30, 67)" v-on="on">
            <v-icon>home</v-icon> UN iLabCC
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="navigateTo('about/1')">
            <v-list-item-title>What is the UN iLabCC?</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('about1/1')">
            <v-list-item-title>Our Mission</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('about2/1')">
            <v-list-item-title>Our Audience</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('about3/1')">
            <v-list-item-title>Participating UN entities</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn text :to="{ name: 'resources' }" color="rgb(0, 30, 67)" :tabindex="userOid ? '0' : '-1'" :style="{ 'pointer-events': userOid ? 'auto' : 'none' }" v-on="on" >
            Policy Guidance, Tools and Resources
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="navigateTo('TCorruption/1')">
            <v-list-item-title>Corruption (live)</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('TOrganizedCrime/2')">
            <v-list-item-title>Organized Crime (live)</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('TCrimePrevention/3')">
            <v-list-item-title>Crime Prevention and Criminal Justice (live)</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('TDrug/4')">
            <v-list-item-title>Drugs (live)</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('TGender/5')">
            <v-list-item-title>Gender-Based Violence (live)</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('TPrison/6')">
            <v-list-item-title>Prison Reform (live)</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('THomicides/8')">
            <v-list-item-title>Homicide (live)</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('TViolence/7')">
            <v-list-item-title>Violence against children (live)</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateTo('TTerrorism/9')">
            <v-list-item-title>Terrorism (live)</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item>
            <v-list-item-title>Citizen security (coming soon)</v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-menu>
        <!--<v-btn text :to="{ name: 'resources' }" color= "rgb(0, 30, 67)">
          Tools and Resources
        </v-btn>-->
        <v-btn text :to="{ name: 'courses' }" color= "rgb(0, 30, 67)" :tabindex="userOid ? '0' : '-1'" :style="{ 'pointer-events': userOid ? 'auto' : 'none' }">
          E-learning
        </v-btn>
        <v-btn text @click="navigateTo('about4/1')" color= "rgb(0, 30, 67)">
          Contact Us
        </v-btn><!--
        <v-btn text :to="{ name: 'Users' }" color= "rgb(0, 30, 67)" :style="{ 'pointer-events': userOid ? 'auto' : 'none' }">
          Users
        </v-btn>
        <v-btn text :to="{ name: 'events' }" color= "rgb(0, 30, 67)">
          Events and Activities
        </v-btn>-->        
      <v-spacer></v-spacer>
      <!--<p style="font-size: 0.8rem; color: rgb(0, 157, 220);"><b>A joint project developed by</b></p>
      <v-img :src="require('@/assets/logo2.png')" max-height="70%" max-width="15%" contain>
        <a href="https://www.unodc.org/unodc/es/index.html" target="_blank" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></a>
      </v-img>
      -->
      <div class="d-flex align-center">
        <h6 style="color: rgb(0, 30, 67)" v-if="userOid != null">Welcome: &nbsp </h6>
        <h6 style="color: rgb(0, 30, 67)" v-if="userOid != null"> {{ userName }}</h6>
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text color="rgb(0, 30, 67)" v-on="on">
              <v-icon>person</v-icon>
              <b v-if="userOid === null">Sign in</b>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="infoUser" v-if="userOid != null">
              <v-list-item-title>Personal Info</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout" v-if="userOid != null">
              <v-list-item-title>Sign off</v-list-item-title>
            </v-list-item>
            <v-list-item @click="signIn" v-if="userOid === null">
              <v-list-item-title>Sign in</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      
    </v-app-bar>
    <v-main>
      <v-container fluid fill-height>
        <v-slide-y-transition mode="out-in">
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-main>
    <v-footer color="rgb(230, 233, 242)" dark height="auto">
      <div class="d-flex flex-column flex-md-row text-center justify-space-between py-4 px-1 px-xl-1">
        <div class="mb-3 mb-md-0" style="color: rgb(0, 30, 67)">
          &copy;Developed by the team of ITS - UNODC ROCOL - 2024 UN iLabCC - Version 1.0.0.1 Privacy          
        </div>
        <v-img :src="require('@/assets/logo2.png')" max-height="100%" max-width="9%" contain>
          <a href="https://www.unodc.org/unodc/es/index.html" target="_blank" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></a>
        </v-img>
      </div>
    </v-footer>

    <!-- Formulario de creación/edición -->      
    <v-form ref="form" @submit.prevent="guardar">
    </v-form>

    <v-dialog v-model="dialog_login" max-width="30%">
      <v-card>
          <div class="col-md-12 col-xl-12">
              <!--<v-img :src="require('../assets/login2.png')" class="my-3" contain height="80" />-->
              <p style="font-size: 2rem; color: rgb(0, 30, 67)"><b>UN Information Laboratory on Crime and Corruption for Latin America and the Caribbean (UN iLabCC)</b></p>
          </div>
          <v-card-title>
              <h2>Sign In</h2>
          </v-card-title>
          <v-card-text>
              <v-form v-if="acceso === 0" ref="loginForm" @submit.prevent="validarYEnviarCodigo">
                  <v-text-field v-model="correo_corporativo" :rules="[validar2]" label="Corporate Email" required></v-text-field>
                  <!--<v-text-field v-model="pswd" :rules="[validar]" label="Contraseña" type="password" required></v-text-field>
                  <v-spacer></v-spacer>
                  <a href="#" class="text-body-2 font-weight-regular" @click="abrir_dialog_forgot">Recover passwpord</a> - 
                  <a href="#" class="text-body-2 font-weight-regular" @click="abrir_dialog_register">Register</a>-->
                  <v-btn style="color: black" x-large block type="submit" class="mt-2" v-if="acceso === 0" :disabled="!isValidForm">Sign In</v-btn>                            
              </v-form>
              <v-form v-if="acceso === 1" ref="loginForm1" @submit.prevent="login1">
                  <v-text-field v-model="correo_corporativo" :rules="[validar2]" label="Corporate Email" required></v-text-field>
                  <v-text-field v-model="code_login" label="Verification code" type="password" required></v-text-field>
                  <!--<v-text-field v-model="pswd" :rules="[validar]" label="Contraseña" type="password" required></v-text-field>
                  <v-spacer></v-spacer>
                  <a href="#" class="text-body-2 font-weight-regular" @click="abrir_dialog_forgot">Recuperar contraseña</a>
                  <a href="#" class="text-body-2 font-weight-regular" @click="abrir_dialog_register">Register</a>-->
                  <v-btn style="color: black" x-large block type="submit" class="mt-2" v-if="acceso === 1" :disabled="!isValidForm1">Sign In</v-btn>                            
              </v-form>
          </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_cargando" max-width="550px"> 
            <v-card>
                <v-card-title class="headline">Sending Code.....</v-card-title>
            </v-card>
    </v-dialog>

    <!-- Dialogo para Mensaje Validando Loginn-->
    <v-dialog v-model="dialog_cargando2" max-width="550px"> 
        <v-card>
            <v-card-title class="headline">Validating .....</v-card-title>
        </v-card>
    </v-dialog>
    <!--Dialogo para actualizar contraseña-->
    <v-dialog v-model="dialog_info" max-width="30%">
      <v-card>
          <v-card-title>
              <span class="text-h5" style="color: gray;">
                <v-icon style="font-size: 30px;">person</v-icon>
                Personal Info
              </span>
          </v-card-title>
          <v-card-text>
              <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                        <v-text-field v-model="datoUser.name" label="Name" ></v-text-field>
                    </v-flex>                                            
                    <v-flex xs12>
                        <v-text-field v-model="datoUser.surname" label="Surname" ></v-text-field>
                    </v-flex>   
                    <v-flex xs12>
                        <v-text-field v-model="datoUser.correo_corporativo" label="Corporate Email" readonly disabled></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 md12>
                        <v-select v-model="datoUser.oid_agency" :items="agencies" item-text="n_agency" item-value="oid" label="Office"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                        <v-select v-model="datoUser.oid_rol" :items="rols" item-text="n_role" item-value="oid" label="Role" readonly disabled></v-select>
                    </v-flex> -->
                    <!--
                    <v-flex xs12 sm12 md6>
                        <v-text-field v-model="datoUser.pswd" label="Password" type="password" readonly disabled></v-text-field> 
                    </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-text-field v-model="datoUser.pswd" :append-icon="verPswd ? 'visibility' : 'visibility'" 
                        :type="verPswd ? 'text' : 'password'" label="New Password" @click:append="verPswd = !verPswd" :rules="[validar]"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-text-field v-model="pswdv" :append-icon="verPswd ? 'visibility' : 'visibility'" 
                        :type="verPswd ? 'text' : 'password'" label="Confirm Password" @click:append="verPswd = !verPswd" :rules="[validar]"></v-text-field>
                      </v-flex>-->
                  </v-layout>
              </v-container>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="guardar">Update</v-btn>
              <v-btn v-if="datoUser.pswd_act === 1" color="secondary" text @click="cerrar_dialog_info">Close</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para Mensaje cargando-->
    <v-dialog v-model="dialog_guardando" max-width="550px"> 
        <v-card>
            <v-card-title class="headline">Saving.....</v-card-title>
        </v-card>
    </v-dialog>

    <!-- Mensaje de confirmación-->
    <v-snackbar v-model="guardarExitoso" color="success" top>
        Saved successfully
        <template v-slot:action="{ attrs }">
            <v-btn color="success" text v-bind="attrs" @click="registroExitoso = false">Close</v-btn>
        </template>
    </v-snackbar>    
    <!-- Mensaje de validación-->
    <v-snackbar v-model="mensajeValidacion" color="error" top  :timeout="3000">
        {{ textoValidacion }}
        <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="registroExitoso = false"></v-btn>
        </template>
    </v-snackbar>    

  </v-app>
</template>
<script>
import axios from 'axios';
import { bus } from '../main.js';

export default {
  name: "App",
  data() {
    return {
      datos: [],
      agencies: [],
      rols: [],
      datoUser: {
          oid: 0,
          name:'',
          surname: '',
          correo_corporativo: '',
          oid_agency: 0,
          oid_rol: 0,
          pswd: '',
          pswd_act: null,
          fecha_pswd_act: null,
      },  
      userNameState: localStorage.getItem('userName'),
      rolOidState: Number(localStorage.getItem('rolu')) || null,
      userOidState: localStorage.getItem('oidu'),
      correo_corporativo: '',
      code_login: '', 
      acceso: 0,
      pswdv: '',
      verPswd: false,
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        {
          icon: "bubble_chart",
          title: "Inspire",
        },
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Vuetify.js",
      mensajeValidacion: false,
      textoValidacion: '',
      dialog_guardando: false,
      guardarExitoso: false,
      dialog_info: false,
      dialog_login: false,      
      dialog_cargando: false,
      dialog_cargando2: false,
      showMenu: false,
    };
  },
  computed: {
    userName() {
      return this.userNameState;
    },
    rolOid() {
        return this.rolOidState;
    },    
    userOid() {
      return this.userOidState;
    },
    isEnviar() {
      if (this.pswdv ===this.datoUser.pswd ) {
          return true;
      } else {
        return false;
      }
    },
    isValidForm() {
        return this.correo_corporativo && this.validar2(this.correo_corporativo) === true;
    },
    isValidForm1() {
        return this.correo_corporativo && this.code_login && this.validar2(this.correo_corporativo) === true;
    },
  },
 /* mounted() {
    this.listar();
  },*/
  created() {
    bus.$on('open-login-dialog', () => {
      this.dialog_login = true;
    });
  },
  methods: {
    syncAuthState({ token = null, userName = null, oid = null, rol = null } = {}) {
      if (token) {
        localStorage.setItem('token', token);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      }

      if (userName !== null) {
        localStorage.setItem('userName', userName);
      }

      if (oid !== null) {
        localStorage.setItem('oidu', oid);
      }

      if (rol !== null) {
        localStorage.setItem('rolu', rol);
      }

      this.userNameState = userName;
      this.userOidState = oid;
      this.rolOidState = rol !== null ? Number(rol) : null;
    },
    async getClientIpFrontend() {
      try {
        const ipResponse = await axios.get('https://ipapi.co/json/', { timeout: 2500 });
        return ipResponse.data.ip || '';
      } catch (error) {
        console.error('No se pudo obtener la IP publica:', error);
        return '';
      }
    },
    toggleMenu() {
        this.showMenu = !this.showMenu; // Cambiar el estado de visibilidad del menú
    },
   /* async listar() {
        try {
            const response = await axios.get('api/Users/Listar');
            const responseagency = await axios.get('api/Agencies/Listar');
            const responserol = await axios.get('api/Roles/Listar');

            this.datos = response.data;
            this.agencies = responseagency.data;
            this.rols = responserol.data;
        } catch (error) {
            console.error(error);
        }
    },*/

        async validarYEnviarCodigo() {
            const infoUser = {
                correo_corporativo: this.correo_corporativo,
            };
            // Realizar una solicitud al servidor para verificar si el correo existe
            const { data: existe } = await axios.post('api/Logins/ValidarCorreo', infoUser);
            if (existe) {
              await this.login();
            } else {
              await this.RegisterNew();
            }
        },

        // Guardar el área creada o actualizada
        async guardar() {            
            // Validar los campos del formulario antes de guardar
              const name = this.datoUser?.name?.trim();
              const surname = this.datoUser?.surname?.trim();

              if (!name || !surname) {
                    this.textoValidacion = 'First Name and Surname cannot be empty';
                    this.mensajeValidacion = true;
                    return;
              }

              this.dialog_guardando = true; 

            try {
                // Realizar la lógica para guardar o actualizar el área                    
                await axios.put('api/Users/Actualizar', this.datoUser);
                
                // Limpiar el formulario después de guardar o actualizar
                this.dato = { oid: 0, name:'', surname: '', correo_corporativo: '', oid_agency: null, oid_rol: 2, pswd: '' };

                // Después de guardar exitosamente el registro:
                this.guardarExitoso = true;
                this.dialog_info = false;
                await this.listar();
                
            } catch (error) {
                console.error(error);
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_guardando = false;
            }
        },

        async RegisterNew() {
            // Validar los campos del formulario antes de guardar
            const nuevoUsuario = {
                correo_corporativo: this.correo_corporativo,
                // Otros datos del usuario, si es necesario...
            };
            try {
                // Realizar la lógica para guardar o actualizar el usuario
                await axios.post('api/Users/RegisterNew', nuevoUsuario);
                
                // Limpiar el formulario después de guardar o actualizar
                this.dato = { oid: 0, correo_corporativo: ''};

                // Después de registrar exitosamente el usuario, enviar correo de verificación
                await this.login();
                
            } catch (error) {
                console.error(error);
            } 
        },
        //FUNCIONES PARA INGRESAR
        async login1() {
            this.dialog_cargando2 = true;
            if (this.$refs.loginForm1.validate()) {
                // Limpiar el mensaje de error
                //this.error = '';
                let loginExitoso = false;

                try {
                    // Realiza la petición HTTP a la API para autenticar al usuario
                    const clientIpFrontend = await this.getClientIpFrontend();

                    const response = await axios.post('api/Logins/Login1', {
                        correo_corporativo: this.correo_corporativo,
                        //pswd: this.pswd,
                        code_login: this.code_login,
                        clientIpFrontend: clientIpFrontend                        
                    });                    
                    // Verificar si la autenticación fue exitosa (status 200)
                    if (response.status === 200 && response.data.userName!=null) {
                        // Si se recibe un token en la respuesta, el inicio de sesión fue exitoso
                        const token = response.data.token;
                        const userName = response.data.userName;
                        const oid = response.data.oid;
                        const rol = response.data.rol;

                        this.syncAuthState({ token, userName, oid, rol });
                        this.dialog_ingresar = true;
                        loginExitoso = true;

                        await this.$router.replace({ name: 'Inicio' }).catch((navigationError) => {
                          if (!navigationError || navigationError.name !== 'NavigationDuplicated') {
                            throw navigationError;
                          }
                        });
                        await this.$nextTick();
                        this.dialog_cargando2 = false;
                        this.dialog_login = false;
                        this.acceso = 0;
                        this.code_login = '';
                    } 
                    else {
                        // Si la respuesta de la API no tiene un estado de 200, mostrar un mensaje de error al usuario
                        this.error = 'Usuario y/o contraseña y/o código incorrectas. Intente nuevamente.';
                        this.aprobar =1;
                        this.codigo_error = true;
                    }
                
                } catch (error) {
                    // Si hay un error en la respuesta, mostrar un mensaje de error al usuario
                    this.error = 'Usuario y/o contraseña y/o código incorrectas. Intente nuevamente.';
                    this.aprobar =1;
                    this.codigo_error = true;
                } finally {
                    // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                  if (!loginExitoso) {
                    this.dialog_cargando2 = false;
                  }
                }
            }
        },
        async login() {
            this.dialog_cargando = true;
            if (this.$refs.loginForm.validate()) {
                // Limpiar el mensaje de error
                //this.error = '';
                try {
                    // Realiza la petición HTTP a la API para autenticar al usuario
                    const response = await axios.post('api/Logins/Login', {
                        correo_corporativo: this.correo_corporativo,
                        //pswd: this.pswd,
                    });
                    // Verificar si la autenticación fue exitosa (status 200)
                    if (response.status === 200 && response.data.token!=null) {
                        // Si se recibe un token en la respuesta, el inicio de sesión fue exitoso
                        this.acceso = 1;
                        this.codigo_enviado = true;
                    } 
                    else {
                        // Si la respuesta de la API no tiene un estado de 200, mostrar un mensaje de error al usuario
                        this.error = 'Usuario y/o contraseña incorrectas. Intente nuevamente.';
                        this.aprobar =1;
                        this.user_error = true;
                    }
                
                } catch (error) {
                    // Si hay un error en la respuesta, mostrar un mensaje de error al usuario
                    this.error = 'Usuario y/o contraseña incorrectas. Intente nuevamente.';
                    this.aprobar =1;
                    this.user_error = true;
                } finally {
                    // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                    this.dialog_cargando = false;
                }
            }
        },
      navigateTo(route) {
          this.$router.push('/' + route);
      },
      async logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('userName');
        localStorage.removeItem('oidu');
        localStorage.removeItem('rolu');
        delete axios.defaults.headers.common['Authorization'];
        this.userNameState = null;
        this.userOidState = null;
        this.rolOidState = null;

        if (this.$route.name !== 'Inicio') {
          await this.$router.replace({ name: 'Inicio' }).catch((navigationError) => {
            if (!navigationError || navigationError.name !== 'NavigationDuplicated') {
              throw navigationError;
            }
          });
        }
      },
      signIn() {
        this.dialog_login = true;
      },
      cerrar_dialog_info() {
          this.dialog_info = false;
      },
      cerrar_dialog_login() {
          this.dialog_login = false;
      },
      async infoUser(dato) {
        const oid_usuario = Number(this.userOid);
        const response = await axios.get(`api/Users/Mostrar/${oid_usuario}`);
        this.datoUser = response.data;  
        this.dialog_info = true;
      },
      validar2(value) {
    // Validar si es IOM con .int o cualquier otro con .org
    const iomIntPattern = /^[A-Za-z0-9._%+-]+@iom\.int$/; // Solo iom.int
    const otherOrgPattern = /^[A-Za-z0-9._%+-]+@(un|undp|cepal|fao|ilo|paho|unaids|unesco|unfpa|unhcr|unicef|unido|unwomen|wfp|unops)\.org$/; // Otros con .org

    if (!iomIntPattern.test(value) && !otherOrgPattern.test(value)) {
        return 'Access is restricted to UN staff only (un-undp-cepal-fao-ilo-paho-unaids-unesco-unfpa-unhcr-unicef-unido-unwomen-wfp|unops).org / iom.int)';
    }

    if (value.length > 500) {
        return 'The field cannot exceed 500 characters';
    }

    /*
    // Realiza una solicitud al servidor para verificar si el correo ya existe y tiene el permiso activo
    const userdata = this.datos.find((user) => user.correo_corporativo === value);

    if (userdata) {
        return 'The user exists';
    }
    */

    return true;
},
      validar(value) {
        if (value && value.length < 12) {
            return 'The password must contain a minimum of 11 characters';
        }
        // Utiliza expresiones regulares para verificar si se cumplen los requisitos.
        const hasLowercase = /[a-z]/.test(value);//minuscula
        const hasUppercase = /[A-Z]/.test(value);//mayuscula
        const hasNumber = /\d/.test(value);//numero
        const hasSpecialChar = /[!@#$%^&*]/.test(value);//caracter especial

        if (!hasLowercase) {
            return 'The password must contain at least one lowercase letter.';
        }

        if (!hasUppercase) {
            return 'The password must contain at least one uppercase letter.';
        }

        if (!hasNumber) {
            return 'The password must contain at least one number.';
        }

        if (!hasSpecialChar) {
            return 'The password must contain at least one special character (for example: !@#$%^&*).';
        }

        return true;
    },
  }
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 16px;        
        line-height: 1.6em;
    }
    .hover-show {
    opacity: 0;
    transition: opacity 0.3s ease;
    position: relative;
}

.hover-show:hover {
    opacity: 1;
}

.menu-indicator {
    position: absolute;
    color: #555; /* Cambia el color de la flecha según tu diseño */
}

</style>